import React, { Component } from "react";

import UiModal from "./UiModal";

import { ReactComponent as LoaderImage } from "../../assets/images/ui/loader.svg";

class UiLoader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const modalInner = (
      <div id="loader" className="loader-overlay">
        <LoaderImage className="loader-gif" />
      </div>
    );
    return (
      <UiModal  
        modal="loader"
        modalInner={modalInner}
        modalOpen={this.props.modalOpen}
        overlayLight
      />
    );
  }
}

export default UiLoader;
